import { createAction } from '../../types/redux';

export const SET_FILTERS = 'candidates2021/SET_FILTERS';

export const setFilters = (obj) => createAction(SET_FILTERS, obj);
